import React from "react";
import { BaseEdge, getStraightPath } from "reactflow";
import type { EdgeProps } from "reactflow";

const ConnectorEdgeComponent: React.FC<EdgeProps> = ({ id, sourceX, sourceY, targetX, targetY }) => {
    const [edgePath] = getStraightPath({ sourceX, sourceY, targetX, targetY });
    return <BaseEdge id={id} path={edgePath} style={{ stroke: "#c2c2c2", strokeWidth: 1.5 }} />;
};

export const ConnectorEdge = React.memo(ConnectorEdgeComponent);
